module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/101GI7a/tc-custom/9781398400481.jpg?1684979381193",
      "alt": "This image is the cover for the book Flicker"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Flicker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After discovering that her nemesis is none other than her friend, Lexi must live to fight another day. But now he knows that she’s a witch. "), _c('br'), _vm._v("Can she survive long enough to her abusive step-father face justice, or are her days numbered? And can she carry on alone, or is there someone out there to help her?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      T.D. Holmes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("T.D. Holmes is a British author based in Northern Ireland, UK. Despite being dyslexic, she loves to read and after a traumatic experience, found solace in writing. Since then, her love for writing grew as she discovered a creative and vivid imagination. "), _c('br'), _vm._v("She describes herself as nerdy with a sarcastic sense of humour. She loves everything Disney and sci-fi. From Doctor Who to Marvel and DC. She has a great love of foxes and dreams to start a conservation charity.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0